// this reducer is used to store the user's location
// this is used to sort hunts / local stops and more
// only active on pages that need sorting

import {createSlice} from '@reduxjs/toolkit';
import {calculateDistance, roundLatLong} from '../../Utils/distanceHelpers';

const initialState = {
  region: {},
  backupRegion: {},
  permissionGiven: 1,
  hasGPSLocationData: 0,
  roundedRegion: {},
  veryRoundedRegion: {},
};

const userLocationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    saveUserLocation(state, {payload: position}) {
      console.log('saveUserLocation', {position});
      if (state.hasGPSLocationData) {
        const currentPosition = state?.region;
        const distanceChangeMinimum = position.distanceChangeMinimum || 100;
        const distanceChange = calculateDistance(
          currentPosition?.latitude,
          currentPosition?.longitude,
          position?.coords?.latitude,
          position?.coords?.longitude,
          'FEET',
        );
        if (distanceChange < distanceChangeMinimum) {
          return console.log('saveUserLocation dont make a change', {
            distanceChangeMinimum,
            distanceChange,
          });
        } else {
          console.log('saveUserLocation make a change', {
            distanceChangeMinimum,
            distanceChange,
          });
        }

        // checking to see if change is above a certain amount
      }

      state.region = {
        latitude: position.coords?.latitude,
        longitude: position.coords?.longitude,
        latitudeDelta: 40,
        longitudeDelta: 60,
      };
      state.accuracy = position.coords?.accuracy;
      state.hasGPSLocationData = 1;

      // checking if rounded region should be updated
      const roundedLat =
        Math.round((position.coords?.latitude || 0) * 1000) / 1000;
      const roundedLong =
        Math.round((position.coords?.longitude || 0) * 1000) / 1000;
      if (
        (roundedLong && roundedLat != state?.roundedRegion?.latitude) ||
        roundedLong != state?.roundedRegion?.longitude
      ) {
        console.log('setting semiRoundedRegion saveUserLocation', {
          roundedLat,
          roundedLong,
        });
        state.roundedRegion = {
          latitude: roundedLat,
          longitude: roundedLong,
          latitudeDelta: 40,
          longitudeDelta: 60,
        };
      } else {
        console.log('semiRoundedRegion already set saveUserLocation', {
          roundedLat,
          roundedLong,
          roundedRegion: state.roundedRegion,
        });
      }

      // checking if very round region should be updated
      const {lat, long} = roundLatLong(
        position.coords?.latitude,
        position.coords?.longitude,
      );
      if (
        (lat && lat != state?.veryRoundedRegion?.latitude) ||
        long != state?.veryRoundedRegion?.longitude
      ) {
        console.log('setting veryRoundedRegion saveUserLocation', {lat, long});
        state.veryRoundedRegion = {
          latitude: lat,
          longitude: long,
          latitudeDelta: 40,
          longitudeDelta: 60,
        };
      } else {
        console.log('veryRoundedRegion already set saveUserLocation', {
          lat,
          long,
          veryRoundedRegion: state.veryRoundedRegion,
        });
      }
    },
    saveBackupRegion(state, {payload: position}) {
      if (!state.region.latitude) {
        state.region = {
          latitude: position.lat,
          longitude: position.long,
          latitudeDelta: 40,
          longitudeDelta: 60,
        };

        // checking if rounded region should be updated
        const roundedLat = Math.round((position.lat || 0) * 1000) / 1000;
        const roundedLong = Math.round((position.long || 0) * 1000) / 1000;
        if (
          (roundedLong && roundedLat != state?.roundedRegion?.latitude) ||
          roundedLong != state?.roundedRegion?.longitude
        ) {
          console.log('setting semiRoundedRegion saveBackupRegion', {
            roundedLat,
            roundedLong,
          });
          state.roundedRegion = {
            latitude: roundedLat,
            longitude: roundedLong,
            latitudeDelta: 40,
            longitudeDelta: 60,
          };
        } else {
          console.log('semiRoundedRegion saveBackupRegion already set', {
            roundedLat,
            roundedLong,
            roundedRegion: state.roundedRegion,
          });
        }

        // checking if very round region should be updated
        const {lat, long} = roundLatLong(position.lat, position.long);
        if (
          lat != state?.veryRoundedRegion?.latitude ||
          long != state?.veryRoundedRegion?.longitude
        ) {
          console.log('setting veryRoundedRegion saveBackupRegion', {
            lat,
            long,
          });
          state.veryRoundedRegion = {
            latitude: lat,
            longitude: long,
            latitudeDelta: 40,
            longitudeDelta: 60,
          };
        } else {
          console.log('veryRoundedRegion already set saveBackupRegion', {
            lat,
            long,
            veryRoundedRegion: state.veryRoundedRegion,
          });
        }
      }
      state.backupRegion = {
        latitude: position.lat,
        longitude: position.long,
        latitudeDelta: 40,
        longitudeDelta: 60,
      };
    },
    setPermissionGiven(state, {payload: permissionGiven}) {
      state.permissionGiven = permissionGiven;
    },
  },
});

export const {saveUserLocation, setPermissionGiven, saveBackupRegion} =
  userLocationSlice.actions;

export default userLocationSlice.reducer;
